"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_GET_PAUSE_OPTIONS = exports.DEFAULT_MEMBERSHIP_MEMBER_ALIAS = void 0;
exports.DEFAULT_MEMBERSHIP_MEMBER_ALIAS = 'membershipMember';
exports.DEFAULT_GET_PAUSE_OPTIONS = {
    activeOnly: false,
};
//# sourceMappingURL=membership.member.consts.js.map